module.exports = __webpack_public_path__ + "static/media/logo-nactalia.d1a46518.png";